import { lazy, memo } from 'react';
import { Route, Routes as RoutesWrapper } from 'react-router-dom';
import { AuthenticatedLayout } from 'components/layout/AuthenticatedLayout';
import { UnauthenticatedLayout } from 'components/layout/UnauthenticatedLayout';

import { Routes } from '../navigation/types';

const Login = lazy(() => import('../pages/login'));
const LogoutSuccess = lazy(() => import('../pages/logoutSuccess'));

const AuthenticationMethodSelection = lazy(() => import('../pages/authenticationMethodSelection'));
const Overview = lazy(() => import('../pages/overview'));
const Deed = lazy(() => import('../pages/deed'));
const DeedPreview = lazy(() => import('../pages/deedPreview'));
const Register = lazy(() => import('../pages/register'));

const Router = memo(() => (
  <RoutesWrapper>
    <Route element={<AuthenticatedLayout />}>
      <Route path={Routes.Overview} element={<Overview />} />
      <Route path={Routes.Deed} element={<Deed />} />
      <Route path={Routes.Register} element={<Register />} />
    </Route>
    <Route path={Routes.DeedPreview} element={<DeedPreview />} />
    <Route element={<AuthenticatedLayout withHeader={false} />}>
      <Route
        path={Routes.AuthenticationMethodSelection}
        element={<AuthenticationMethodSelection />}
      />
    </Route>
    <Route element={<UnauthenticatedLayout />}>
      <Route path={Routes.Login} element={<Login />} />
      <Route path={Routes.LogoutSuccess} element={<LogoutSuccess />} />
    </Route>
  </RoutesWrapper>
));

Router.displayName = 'MemoRouter';

export default Router;
